import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { bottom } from '@popperjs/core';
import { MarketSignalStreamAnalysisTopic } from '@/modules/market-signals/model/market-signals/market-signal-stream-analysis';

export const topicFontSize = (topic: MarketSignalStreamAnalysisTopic): string => {
  if (topic.relevance >= 0.9) return 'fw-bold ';
  else if (topic.relevance >= 0.6) return 'fw-normal ';
  else if (topic.relevance >= 0.4) return 'fw-light ';

  return 'fw-lighter ';
};

const topicBG = (topic: MarketSignalStreamAnalysisTopic): string => {
  //if (topic.sentiment > 0.5) return 'bg-success border text-black';
  // else if (topic.sentiment > 0.5) return 'bg-success-subtle border';
  // else if (topic.sentiment < -0.5) return 'bg-danger border';
  // else if (topic.sentiment < 0) return 'bg-danger-subtle border';

  return 'bg-primary border';
};

export const MarketSignalTopicTooltip = (props: {
  topic: MarketSignalStreamAnalysisTopic;
  hide?: boolean;
}) =>
  props.hide ? (
    <></>
  ) : (
    <Tooltip id="button-tooltip" {...props}>
      <h4>{props.topic.text}</h4>
      <p>{props.topic.context}</p>

      <p className={'fw-light text-muted'}>Mentioned in {props.topic.ids.length} article(s).</p>
    </Tooltip>
  );

export default function MarketSignalTopicBadge({
  value,
  index,
  onClick,
  showTooltips,
  key,
  text,
}: {
  key: string;
  showTooltips: boolean;
  value: MarketSignalStreamAnalysisTopic;
  index: number;
  onClick: (s: MarketSignalStreamAnalysisTopic) => void;
  text?: string | JSX.Element;
}) {
  if (!text)
    text = (
      <>
        {index + 1}: {value.text} <span className={'fw-light'}> ({value.ids.length})</span>
      </>
    );

  return (
    <span
      key={key}
      onClick={event => onClick(value)}
      className={`badge text-wrap fw-light ${topicBG(value)} ${topicFontSize(value)} mb-1 me-1`}
    >
      <OverlayTrigger
        placement={bottom}
        overlay={injected => MarketSignalTopicTooltip({ ...injected, topic: value })}
      >
        <span>{text}</span>
      </OverlayTrigger>
    </span>
  );
}
